import { render, staticRenderFns } from "./TaskOptions.vue?vue&type=template&id=81a198a8&scoped=true&"
import script from "./TaskOptions.vue?vue&type=script&lang=ts&"
export * from "./TaskOptions.vue?vue&type=script&lang=ts&"
import style0 from "./TaskOptions.vue?vue&type=style&index=0&id=81a198a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a198a8",
  null
  
)

export default component.exports